import { Quill } from "react-quill";

// Add sizes to whitelist and register them
const Size = Quill.import("formats/size");
Size.whitelist = ["small", "false", "large", "huge"];
Quill.register(Size, true);

// function undoChange() {
//     this.quill.history.undo();
// }
// function redoChange() {
//     this.quill.history.redo();
// }


// // Modules object for setting up the Quill editor
export const modules = {
    toolbar: {
        container: "#toolbar",
        // handlers: {
        //     undo: undoChange,
        //     redo: redoChange
        // }
    },
    history: {
        delay: 500,
        maxStack: 100,
        userOnly: true
    }
};

// Formats objects for setting up the Quill editor
// export const formats = [
//     "header",
//     "font",
//     "size",
//     "bold",
//     "italic",
//     "underline",
//     "align",
//     "strike",
//     "script",
//     "blockquote",
//     "background",
//     "list",
//     "bullet",
//     "indent",
//     "link",
//     "image",
//     "color",
//     "code-block"
// ];

// export const modules = {
//   toolbar: [
//     [{ 'header': [1, 2, false] }],
//     ['bold', 'italic', 'underline', 'strike'],
//     [{ 'list': 'ordered'}, { 'list': 'bullet' }],
//     ['link', 'image'],
//     ['clean']
//   ]
// };

export const formats = [
    "font", "size",
  'header', 'bold', 'italic', 'underline', 'strike',
  'list', 'bullet', 'link', 'image'
];
